export const grnStatusList = [
  { label: "Draft", value: "draft" },
  { label: "Approval In Progress", value: "approval_in_progress" },
  { label: "Approved", value: "approved" },
  { label: "Rejected", value: "rejected" },
  { label: "Inactive", value: "inactive" },
  { label: "Reconsidered", value: "reconsider" },
  { label: "Hold", value: "hold" },
  { label: "Created By Vendor", value: "created_by_vendor" },
];
